var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.444v4a1.63 1.63 0 01-.503 1.121 1.571 1.571 0 01-1.133.434H2.636a1.57 1.57 0 01-1.133-.434A1.63 1.63 0 011 11.444v-4a.56.56 0 01.16-.393.54.54 0 01.771 0 .56.56 0 01.16.393v4c.018.13.084.25.186.333.101.083.23.122.36.111h8.727a.501.501 0 00.36-.111.519.519 0 00.185-.333v-4a.56.56 0 01.16-.393.54.54 0 01.771 0 .56.56 0 01.16.393zm-7.315-1.76l.77-.79v4.772a.56.56 0 00.16.393.54.54 0 00.77 0 .56.56 0 00.16-.393V4.894l.77.79a.545.545 0 00.387.163.537.537 0 00.387-.164.556.556 0 00.158-.394.564.564 0 00-.158-.395L7.387 3.161A.541.541 0 007.038 3h-.103a.54.54 0 00-.295.133h-.027L4.91 4.894a.563.563 0 000 .79.543.543 0 00.774 0z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport1);
export default __webpack_public_path__ + "static/media/export 1.5c0e5bbd712464607a5e32bfbc6557eb.svg";
export { ForwardRef as ReactComponent };